<template>
  <menu class="map-filters">
    <li class="map-filters__item">
      <div class="input -flat map-filters__search" id="places-search-container">
        <label for="placesSearchInput" class="input__label">{{ $t('search_by_location') }}</label>
        <input
          id="placesSearchInput"
          ref="placesSearchInput"
          v-model="queryPlaces"
          type="text"
          class="input__field"
        />
      </div>

      <button class="button -inline">GO</button>
    </li>

    <li class="map-filters__item">
      <p class="filter-select__label">{{ $t('filter_by') }}</p>

      <div class="filter-select__list">
        <FilterSelect
          param="businessUnit"
          :options="businessUnits"
          :placeholder="$t('business_unit')"
          class="map-filters__field"
        />

        <p class="filter-select__separator">{{ $t('or') }}</p>

        <FilterSelect
          param="productType"
          :options="productTypes"
          :placeholder="$t('product_type')"
          class="map-filters__field"
        />
      </div>
    </li>
  </menu>
</template>

<script>
import FilterSelect from './FilterSelect.vue'

export default {
  name: 'GoogleMapFilters',
  components: { FilterSelect },
  props: {
    mapsApiContext: { type: Object, default: null },
    pseudoProducts: { type: Object, default: Object },
  },
  data() {
    return {
      queryPlaces: '',
      placeResult: null,
      autocompleteInitialized: false,
    }
  },
  computed: {
    businessUnits() {
      return this.$store.getters.business_units.reduce(
        (buMap, unit) => {
          return { ...buMap, [unit.slug]: unit.name }
        },
        { office: this.$t('office') },
      )
    },
    productTypes() {
      return this.$store.getters.products.reduce((buMap, unit) => {
        return { ...buMap, [unit.slug]: unit.name }
      }, this.pseudoProducts)
    },
  },
  watch: {
    mapsApiContext: {
      handler() {
        this.initAutocomplete()
      },
      immediate: true,
    },
  },
  methods: {
    initAutocomplete() {
      if (!this.mapsApiContext || this.autocompleteInitialized) return
      if (!this.$refs.placesSearchInput) return
      this.autocompleteInitialized = true
      const { places } = this.mapsApiContext
      if (places.PlaceAutocompleteElement) {
        const placeAutocomplete = new places.PlaceAutocompleteElement()
        placeAutocomplete.addEventListener('gmp-placechange', () => {
          const place = placeAutocomplete.value
          if (place && place.location) this.$emit('place-changed', place.location)
        })
        const container = document.getElementById('places-search-container')
        container.appendChild(placeAutocomplete)
      }
    },
  },
}
</script>
